import {layoutSelectors} from 'features/layout/redux';
import {flatMap} from 'lodash';
import {State} from 'redux/reducer';
import {createSelector} from 'reselect';
import {keysKey} from './types';

export const pgpSshKeys = createSelector(layoutSelectors.keysSelector, (o) => [
   ...o.openpgp.publicKeys,
   ...o.openpgp.secretKeys,
   ...o.ssh.clientKeys,
]); // TODO where ssh secret keys?

export const isFetching = (state: State) => state[keysKey].isFetching;
